// import Link from "next/link";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { ReactComponent as WelcomeSvg } from "../assets/svg/wellcome-logo.svg";

interface FooterProps {
  isFull: boolean;
}

const navItems = [
  { label: "Sitemap", path: "/sitemap", external: false },
  { label: "Privacy & cookies", path: "/privacy", external: false },
  { label: "boots.com", path: "/boots", external: false },
];

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.hotPink};
  color: ${({ theme }) => theme.colors.white};
`;

const Top = styled.div`
  padding: 20px 20px 20px 40px;
  font-size: 1.4rem;
`;

const Divider = styled.div`
  height: 1px;
  opacity: 21%;
  background-color: white;
`;

const Bottom = styled.div`
  padding: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
  font-size: 1.2rem;

  a {
    color: inherit;
    text-decoration: none;
  }
`;

const Nav = styled.ul`
  display: flex;
  margin: 0 16px;
`;

const NavItem = styled.li`
  margin: 0 8px;
`;

const LogoContainer = styled.div`
  /* width: 40px;
  height: 40px; */
  display: flex;
  align-items: center;
  font-weight: 400;

  svg {
    width: 40px;
    height: 40px;
    margin-right: 16px;
  }
`;

export const Footer: React.FC<FooterProps> = ({ isFull = true }) => {
  return (
    <Wrapper>
      <Top>
        <LogoContainer>
          <WelcomeSvg />
          <span>In association with Wellcome</span>
        </LogoContainer>
      </Top>
      {isFull ? (
        <>
          <Divider />
          <Bottom>
            <span>© The Boots Company PLC </span>
            <Nav>
              {navItems.map((navItem) => (
                <NavItem key={navItem.path}>
                  <Link
                    to={navItem.path}
                    target={navItem.external ? "_blank" : ""}
                  >
                    {navItem.label}
                  </Link>
                </NavItem>
              ))}
            </Nav>
          </Bottom>
        </>
      ) : null}
    </Wrapper>
  );
};
